<template>
  <footer class="footer">
    <div class="footer-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="footer-informations">
              <ul>
                <li>
                  <i class="fa fa-phone" aria-hidden="true"></i>
                  [69] <strong>3217-2100</strong>
                </li>
                <li>
                  <i class="fa fa-phone" aria-hidden="true"></i>
                  [69] <strong>3217-2101</strong>
                </li>
                <li>
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                  Rua Paulo Leal, 1300, São Cristóvão, Porto Velho/RO, CEP 76.804-128
                </li>
                <li>
                  <a href="http://www.oab-ro.org.br/" target="_blank">
                    Visitar o site da OAB/RO
                  </a>
                </li>
              </ul>
            </div>
            <!-- /.footer-informations -->
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container -->

      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="footer-copyright">
              <div class="footer-copyright-text">
                Ordem dos Advogados do Brasil - Seccional Rondônia -
                &copy; {{ new Date().getFullYear() }} - Todos os Direitos Reservados
              </div>
              <!-- /.footer-copyright-text -->

              <div class="footer-copyright-logo">
                <a href="https://netpix.com.br/" target="_blank">
                  <img src="../assets/images/icon-netpix.png" alt="NETPIX Agência Web">
                </a>
              </div>
              <!-- /.footer-copyright-logo -->
            </div>
            <!-- /.footer-copyright -->
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container -->
    </div>
    <!-- /.footer-wrapper -->
  </footer>
  <!-- /.footer -->
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped lang="scss">
  .footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    height: 240px;
    margin-top: -240px;

    background-color: #212c40;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    padding: 0;
    margin: 0;

    li {
      list-style: none;
    }
  }

  .footer-copyright,
  li,
  a {
    font-family: 'Lato', sans-serif;
    font-weight: 300;

    color: #ffffff;
  }

  .footer-informations {
    li {
      margin-right: 10px;

      &:last-child {
        flex: 0 0 100%;
        margin: 0 !important;
      }
    }

    a {
      display: block;
      width: 100%;
      padding: 15px 20px;
      margin-top: 10px;

      text-align: center;

      background-color: #049aec;

      border-radius: 50px;
    }
  }

  i {
    display: inline-block;
    margin-right: 5px;

    color: #009aec;
  }

  ul,
  .footer-copyright-logo,
  .footer-copyright {
    display: flex;
    flex-wrap: wrap;
  }

  .footer-copyright {
    justify-content: space-between;
    padding: 5px 0;
  }

  .footer-informations {
    padding-bottom: 10px;
    margin-bottom: 5px;

    border-bottom: 1px solid #414e66;
  }

  .footer-copyright-text {
    flex: 0 0 calc(100% - 50px);
    width: calc(100% - 50px);

    font-size: 14px;
    line-height: 18px;
  }

  .footer-copyright-logo {
    width: 25px;
    align-items: center;

    text-align: center;
  }

  @media (min-width: 1024px) {
    .footer {
      height: 140px;
      margin-top: -140px;
    }

    li {
      display: flex;
      align-items: center;

      font-size: 12px;

      & + li {
        margin-left: 20px;
      }

      &:last-child {
        flex: 0 0 auto !important;
      }
    }

    .footer-informations {
      a {
        display: inline-block;
        width: 220px;
        padding: 15px;
        margin: 0 0 0 20px !important;
      }
    }
  }

  @media (min-width: 1366px) {
    .footer {
      height: 125px;
      margin-top: -125px;
    }

    li {
      font-size: 16px;
    }
  }
</style>
